import { Outlet } from "react-router-dom";
import UserTabs from "./UserTabs";

const User = () => {
  return (
    <div className="user-container">
      {/* You could put a sidebar, header, or tab nav here */}
      <UserTabs />
      <Outlet />
    </div>
  );
};

export default User;